<template>
  <div id="projectAudioMenuTmpl">
    <div class="menu">
      <!-- Menu Items -->
      <el-form :model="menuData" ref="projectAudioMenuForm" id="projectAudioMenuForm" @submit.prevent>
        <template v-for="(menuItem, menuItemKey) in menuItems" :key="menuItemKey">
          <el-form-item :id="menuItem.id" :class="['property', 'section-wrapper', menuItem.id]">

            <!-- Name -->
            <template v-if="menuItem.id === 'name'">
              <div class="title">{{menuItem.name}}</div>

              <div class="content name">
                <template v-if="menuItem.editable">
                  <el-input v-model="menuData.name"
                    class="cstm-input-grey"
                    :ref="'playListInputName'"
                    :placeholder="menuData.name"
                    @change="handleMenuItemChange($event, menuItem.type, menuItem.id)"
                    @keydown.enter="handleInputNameEnter">
                  </el-input>
                </template>
                <template v-else><div class="text-lbl" @click="handlePropertyClick(menuItem.id)">{{menuData.name}}</div></template>
              </div>
            </template>

            <!-- Tags -->
            <template v-if="menuItem.id === 'tags' && showTagsMenuItem">
              <div class="title">{{menuItem.name}}</div>

              <div class="content tags">
                <tags-menu-item
                  :tagsSummaryProp="tagsSummaryForSuggestions"
                  :tagsProp="menuData.tags"
                  :classProp="'project-template-tags'"
                  @tags-change="handleMenuItemChange($event, menuItem.type, menuItem.id)">
                </tags-menu-item>
              </div>
            </template>
          </el-form-item>
        </template>
      </el-form>
    </div>
  </div>
</template>
<script src="./project-audio-menu.js"></script>
<style lang="scss" src="./project-audio-menu.scss"></style>
